import home from './home';
import verify from './verify';
import providers from './providers';
import evaluations from './evaluations';
import reports from './reports';
import providerForms from './provider-forms'

export default [
    ...home,
    ...verify,
    ...providers,
    ...evaluations,
    ...reports,
	...providerForms
];